  <!-- Selected Instructions Drag & Drop List -->
  <div class="selected-list-wrapper">
    <h3>Available Instructions</h3>
    <p>Select an instruction from the table to add it to your workflow.</p>
    @if (
      instructionForm &&
      instructionForm.get('instructions')?.invalid &&
      instructionForm.get('instructions')?.touched
    ) {
      <mat-error class="mat-mdc-form-field-error error">At least one instruction is required.</mat-error>
    }
    <kendo-grid
      class="table-wrapper"
      [kendoGridBinding]="gridView"
      [sortable]="true"
      [resizable]="true"
      [pageSize]="pageSize"
      [pageable]="true"
      [columnMenu]="{ filter: true }"
      [scrollable]="'none'"
      [kendoGridExpandDetailsBy]="expandDetailsBy"
      [(expandedDetailKeys)]="expandedDetailKeys"
      kendoGridSelectBy="id"
      [(selectedKeys)]="selectedKeys"
      (selectionChange)="onSelectItem($event)"
      (selectedKeysChange)="onSelectionChange($event)"
      [selectable]="true">

      <kendo-grid-checkbox-column field="checkboxField" [width]="45" [class]="{ 'text-center': true }"
                                  [resizable]="false" [columnMenu]="false"
                                  [showSelectAll]="true"></kendo-grid-checkbox-column>

      <ng-template kendoGridToolbarTemplate>
        <kendo-textbox
          [style.width.px]="350"
          placeholder="Search instructions..."
          (valueChange)="onFilter($event)"></kendo-textbox>
        <!-- Info button -->
        <app-info-button-tooltip
          tooltipText="This search bar filters on all columns and details of the instructions."
          tooltipPosition="above"/>

        <button kendoButton type="button" #sortButton
            (click)="sortCheckboxColumn()" [disabled]="this.selectedKeys.length === 0" class="btn-sort" [svgIcon]="sortIcon">
        Sort by Selected Instruction(s)
      </button>
      <kendo-grid-spacer></kendo-grid-spacer>
      </ng-template>

      <kendo-grid-column field="details.name" title="Name"></kendo-grid-column>

      <kendo-grid-column field="details.description" title="Description"></kendo-grid-column>
      <kendo-grid-column field="details.type" title="Type" [width]="typeColumnWidth"></kendo-grid-column>
      <kendo-grid-column
        field="modifiedDate"
        title="Modified Date"
        [width]="dateModifiedColumnWidth">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.modifiedDate | date:'MM/dd/yyyy, h:mm a' }}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column
        field="createdDate"
        title="Created Date"
        [width]="dateColumnWidth">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.createdDate | date:'MM/dd/yyyy' }}</span>
        </ng-template>
      </kendo-grid-column>

  <!-- Action Column -->
  <kendo-grid-command-column title="Actions" [width]="70">
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      <button matButton type="button"
              class="btn-action"
              #tooltip="matTooltip"
              matTooltip="Summary"
              matTooltipPosition="above"
              aria-label="Instruction Summary"
              (click)="onSummary(dataItem, $event)">
        <mat-icon class="material-symbols-outlined" fontIcon="info" />
      </button>
      <!-- TODO uncomment when we implement edit and clone functionality from this table -->
      <!-- TODO make this along with the summary into an ellipsis with a drop down for all actions. Similar to the Automation/Prompt Library -->
    <!-- @if (canUserEditInstruction(dataItem)) { -->
      <!-- <button matButton type="button"
              class="btn-action"
              #tooltip="matTooltip"
              matTooltip="Edit"
              matTooltipPosition="above"
              aria-label="Edit instruction"
              (click)="onEdit(dataItem)">
        <mat-icon class="material-symbols-outlined" fontIcon="edit" />
      </button>
      <button matButton type="button"
              class="btn-action"
              #tooltip="matTooltip"
              matTooltip="Clone"
              matTooltipPosition="above"
              aria-label="Clone instruction"
              (click)="onClone(dataItem)">
        <mat-icon class="material-symbols-outlined" fontIcon="content_copy" />
      </button> -->
      <!-- <button matButton type="button"
              class="btn-action"
              #tooltip="matTooltip"
              matTooltip="Delete"
              matTooltipPosition="above"
              aria-label="Delete instruction"
              (click)="onDelete(dataItem)">
        <mat-icon class="material-symbols-outlined" fontIcon="delete" />
      </button> -->
    <!-- } -->

    </ng-template>
  </kendo-grid-command-column>

      <!-- Detail template -->
      <ng-template kendoGridDetailTemplate let-dataItem>
        <div class="list-wrapper">
          <kendo-listview
            class="details"
            [data]="dataItem.details.sensitivityLabels"
            containerClass="k-d-flex k-flex-col k-flex-nowrap">
            <ng-template kendoListViewHeaderTemplate>
              @if (dataItem.details.sensitivityLabels && dataItem.details.sensitivityLabels.length > 0) {
                <div><strong>Sensitivity Labels</strong></div>
              }
            </ng-template>

            <ng-template
              kendoListViewItemTemplate
              let-dataItem="dataItem">
              <span class="list-item">{{ agentService.getSensitivityLabelString(dataItem) }}</span>
            </ng-template>
          </kendo-listview>

          <kendo-listview
            class="details"
            [data]="dataItem.details.owners"
            containerClass="k-d-flex k-flex-col k-flex-nowrap">
            <ng-template kendoListViewHeaderTemplate>
              <div><strong>Owners</strong></div>
            </ng-template>

            <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
              <span class="list-item">{{ dataItem.name }}</span>
            </ng-template>
          </kendo-listview>

          <kendo-listview
            class="details"
            [data]="dataItem.details.users"
            containerClass="k-d-flex k-flex-col k-flex-nowrap">
            <ng-template kendoListViewHeaderTemplate>
              @if (dataItem.details.users && dataItem.details.users.length > 0) {
                <div><strong>Users</strong></div>
              }
            </ng-template>
            <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
              <span class="list-item">{{ dataItem.name }}</span>
            </ng-template>
          </kendo-listview>

          <kendo-listview
            class="details"
            [data]="dataItem.details.groups"
            containerClass="k-d-flex k-flex-col k-flex-nowrap">
            <ng-template kendoListViewHeaderTemplate>
              @if (dataItem.details.groups && dataItem.details.groups.length > 0) {
                <div><strong>Groups</strong></div>
              }
            </ng-template>
            <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
              <span class="list-item">{{ dataItem.displayName }}</span>
            </ng-template>
          </kendo-listview>
        </div>
      </ng-template>

      <!-- Pager template -->
      <ng-template
        kendoPagerTemplate
        let-totalPages="totalPages"
        let-currentPage="currentPage">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons [buttonCount]="2"></kendo-pager-numeric-buttons>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
        <kendo-pager-input></kendo-pager-input>
        <kendo-pager-info></kendo-pager-info>
        <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
      </ng-template>
    </kendo-grid>
  </div>

  <div>
    <h3>Workflow Instructions</h3>
    <p>A list of instructions in your workflow.</p>
    @if (selectedInstructions.length > 0) {
      <p>
        Instructions are executed in the order they appear in the list for your workflow.
        You can order your instructions by drag and dropping or using the up and down buttons.
      </p>
      <div
        cdkDropList
        [cdkDropListData]="selectedInstructions"
        (cdkDropListDropped)="onDragAndDropInstruction($event)"
        class="drag-drop-list">
        @for (item of selectedInstructions; track item.id; let idx = $index) {
          <div class="drag-drop-item" cdkDrag>
            <div class="drag-drop-item-placeholder" *cdkDragPlaceholder></div>
            <div class="dnd-list-item">
              <button matIconButton
                      class="btn-dnd"
                      type="button"
                      aria-label="Drag and Drop with mouse"
                      #tooltip="matTooltip"
                      matTooltipPosition="above"
                      matTooltip="Drag and drop with mouse">
                <mat-icon fontIcon="reorder"/>
              </button>
              <span class="idx">{{ idx + 1 }}.</span> <span>{{ item.details.name }}</span></div>
            <div class="btn-group">
              <button matIconButton
                      type="button"
                      aria-label="Move up"
                      [disabled]="idx === 0"
                      (click)="moveInstructionUp(idx)"
                      #tooltip="matTooltip"
                      matTooltipPosition="above"
                      matTooltip="Move up">
                <mat-icon fontIcon="keyboard_arrow_up"/>
              </button>
              <button matIconButton
                      type="button"
                      aria-label="Move down"
                      (click)="moveInstructionDown(idx)"
                      #tooltip="matTooltip"
                      matTooltipPosition="above"
                      matTooltip="Move down">
                <mat-icon fontIcon="keyboard_arrow_down"/>
              </button>
              <button matIconButton
                      type="button"
                      aria-label="Delete"
                      (click)="removeInstruction(item.id)"
                      #tooltip="matTooltip"
                      matTooltipPosition="above"
                      matTooltip="Delete">
                <mat-icon class="material-symbols-outlined" fontIcon="delete"/>
              </button>
            </div>
          </div>
        }
      </div>
    } @else {
      <p>No instructions selected</p>
    }
  </div>
